import { render, staticRenderFns } from "./ContentProducts.vue?vue&type=template&id=1eafa55b&scoped=true&"
import script from "./ContentProducts.vue?vue&type=script&lang=js&"
export * from "./ContentProducts.vue?vue&type=script&lang=js&"
import style0 from "./ContentProducts.vue?vue&type=style&index=0&id=1eafa55b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eafa55b",
  null
  
)

export default component.exports